import classNames from 'classnames';
import React from 'react';
import Button from '../Button';
import Icon from '../Icon';
import { IconName } from '../Icon/constants';
import { BASE_CLASS_NAME } from './constants';

export interface FabProps {
  id?: string;
  icon: IconName;
  onClick?: () => void;
  isDisabled?: boolean;
}

const Fab: React.FC<FabProps> = ({ icon, onClick, id, isDisabled = false }) => {
  return (
    <Button
      id={id}
      color="none"
      disabled={isDisabled}
      className={classNames(BASE_CLASS_NAME, {
        [`${BASE_CLASS_NAME}--disabled`]: isDisabled,
      })}
      iconOnly={true}
      shape="round"
      onClick={onClick}
    >
      <Icon name={icon} size="small" />
    </Button>
  );
};

export default Fab;
